//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  um: "ABD Küçük Harici Adaları",
  vi: "ABD Virjin Adaları",
  af: "Afganistan",
  ax: "Åland Adaları",
  de: "Almanya",
  us: "Amerika Birleşik Devletleri",
  as: "Amerikan Samoası",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarktika",
  ag: "Antigua ve Barbuda",
  ar: "Arjantin",
  al: "Arnavutluk",
  aw: "Aruba",
  au: "Avustralya",
  at: "Avusturya",
  az: "Azerbaycan",
  bs: "Bahamalar",
  bh: "Bahreyn",
  bd: "Bangladeş",
  bb: "Barbados",
  eh: "Batı Sahra",
  by: "Belarus",
  be: "Belçika",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  ae: "Birleşik Arap Emirlikleri",
  gb: "Birleşik Krallık",
  bo: "Bolivya",
  ba: "Bosna-Hersek",
  bw: "Botsvana",
  bv: "Bouvet Adası",
  br: "Brezilya",
  io: "Britanya Hint Okyanusu Toprakları",
  vg: "Britanya Virjin Adaları",
  bn: "Brunei",
  bg: "Bulgaristan",
  bf: "Burkina Faso",
  bi: "Burundi",
  bt: "Butan",
  cv: "Cape Verde",
  ky: "Cayman Adaları",
  gi: "Cebelitarık",
  dz: "Cezayir",
  cx: "Christmas Adası",
  dj: "Cibuti",
  cc: "Cocos (Keeling) Adaları",
  ck: "Cook Adaları",
  ci: "Côte d’Ivoire",
  cw: "Curaçao",
  td: "Çad",
  cz: "Çekya",
  cn: "Çin",
  hk: "Çin Hong Kong ÖİB",
  mo: "Çin Makao ÖİB",
  dk: "Danimarka",
  do: "Dominik Cumhuriyeti",
  dm: "Dominika",
  ec: "Ekvador",
  gq: "Ekvator Ginesi",
  sv: "El Salvador",
  id: "Endonezya",
  er: "Eritre",
  am: "Ermenistan",
  ee: "Estonya",
  sz: "Esvatini",
  et: "Etiyopya",
  fk: "Falkland Adaları",
  fo: "Faroe Adaları",
  ma: "Fas",
  fj: "Fiji",
  ph: "Filipinler",
  ps: "Filistin Bölgeleri",
  fi: "Finlandiya",
  fr: "Fransa",
  gf: "Fransız Guyanası",
  tf: "Fransız Güney Toprakları",
  pf: "Fransız Polinezyası",
  ga: "Gabon",
  gm: "Gambiya",
  gh: "Gana",
  gn: "Gine",
  gw: "Gine-Bissau",
  gd: "Grenada",
  gl: "Grönland",
  gp: "Guadeloupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gy: "Guyana",
  za: "Güney Afrika",
  gs: "Güney Georgia ve Güney Sandwich Adaları",
  kr: "Güney Kore",
  ss: "Güney Sudan",
  ge: "Gürcistan",
  ht: "Haiti",
  hm: "Heard Adası ve McDonald Adaları",
  hr: "Hırvatistan",
  in: "Hindistan",
  nl: "Hollanda",
  hn: "Honduras",
  iq: "Irak",
  ir: "İran",
  ie: "İrlanda",
  es: "İspanya",
  il: "İsrail",
  se: "İsveç",
  ch: "İsviçre",
  it: "İtalya",
  is: "İzlanda",
  jm: "Jamaika",
  jp: "Japonya",
  je: "Jersey",
  kh: "Kamboçya",
  cm: "Kamerun",
  ca: "Kanada",
  me: "Karadağ",
  bq: "Karayip Hollandası",
  qa: "Katar",
  kz: "Kazakistan",
  ke: "Kenya",
  cy: "Kıbrıs",
  kg: "Kırgızistan",
  ki: "Kiribati",
  co: "Kolombiya",
  km: "Komorlar",
  cg: "Kongo - Brazavil",
  cd: "Kongo - Kinşasa",
  cr: "Kosta Rika",
  kw: "Kuveyt",
  kp: "Kuzey Kore",
  mk: "Kuzey Makedonya",
  mp: "Kuzey Mariana Adaları",
  cu: "Küba",
  la: "Laos",
  ls: "Lesotho",
  lv: "Letonya",
  lr: "Liberya",
  ly: "Libya",
  li: "Liechtenstein",
  lt: "Litvanya",
  lb: "Lübnan",
  lu: "Lüksemburg",
  hu: "Macaristan",
  mg: "Madagaskar",
  mw: "Malavi",
  mv: "Maldivler",
  my: "Malezya",
  ml: "Mali",
  mt: "Malta",
  im: "Man Adası",
  mh: "Marshall Adaları",
  mq: "Martinik",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Meksika",
  eg: "Mısır",
  fm: "Mikronezya",
  mn: "Moğolistan",
  md: "Moldova",
  mc: "Monako",
  ms: "Montserrat",
  mr: "Moritanya",
  mz: "Mozambik",
  mm: "Myanmar (Burma)",
  na: "Namibya",
  nr: "Nauru",
  np: "Nepal",
  ne: "Nijer",
  ng: "Nijerya",
  ni: "Nikaragua",
  nu: "Niue",
  nf: "Norfolk Adası",
  no: "Norveç",
  cf: "Orta Afrika Cumhuriyeti",
  uz: "Özbekistan",
  pk: "Pakistan",
  pw: "Palau",
  pa: "Panama",
  pg: "Papua Yeni Gine",
  py: "Paraguay",
  pe: "Peru",
  pn: "Pitcairn Adaları",
  pl: "Polonya",
  pt: "Portekiz",
  pr: "Porto Riko",
  re: "Reunion",
  ro: "Romanya",
  rw: "Ruanda",
  ru: "Rusya",
  bl: "Saint Barthelemy",
  sh: "Saint Helena",
  kn: "Saint Kitts ve Nevis",
  lc: "Saint Lucia",
  mf: "Saint Martin",
  pm: "Saint Pierre ve Miquelon",
  vc: "Saint Vincent ve Grenadinler",
  ws: "Samoa",
  sm: "San Marino",
  st: "Sao Tome ve Principe",
  sn: "Senegal",
  sc: "Seyşeller",
  rs: "Sırbistan",
  sl: "Sierra Leone",
  sg: "Singapur",
  sx: "Sint Maarten",
  sk: "Slovakya",
  si: "Slovenya",
  sb: "Solomon Adaları",
  so: "Somali",
  lk: "Sri Lanka",
  sd: "Sudan",
  sr: "Surinam",
  sy: "Suriye",
  sa: "Suudi Arabistan",
  sj: "Svalbard ve Jan Mayen",
  cl: "Şili",
  tj: "Tacikistan",
  tz: "Tanzanya",
  th: "Tayland",
  tw: "Tayvan",
  tl: "Timor-Leste",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad ve Tobago",
  tn: "Tunus",
  tc: "Turks ve Caicos Adaları",
  tv: "Tuvalu",
  tr: "Türkiye",
  tm: "Türkmenistan",
  ug: "Uganda",
  ua: "Ukrayna",
  om: "Umman",
  uy: "Uruguay",
  jo: "Ürdün",
  vu: "Vanuatu",
  va: "Vatikan",
  ve: "Venezuela",
  vn: "Vietnam",
  wf: "Wallis ve Futuna",
  ye: "Yemen",
  nc: "Yeni Kaledonya",
  nz: "Yeni Zelanda",
  gr: "Yunanistan",
  zm: "Zambiya",
  zw: "Zimbabve",
};
